// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"breadcrumb_Wrapper__JEtfc","Link":"breadcrumb_Link__DOoWq","dev":"breadcrumb_dev__B6G0Z","Separator":"breadcrumb_Separator__MoL_0"};